import React, { FC, useEffect, useState } from 'react';
import { __AddIBanModalProps } from './addIBanModal.interface';
import { SiPayModal } from 'utilities/components';
import { Button, Input } from '30pay/components';
import { detectBankByIBan, faNumToEnNum, post } from 'scripts';
import { BankIcon } from 'utilities/components';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import { API } from 'data/30pay.api';

export const AddIBanModal: FC<__AddIBanModalProps> = (props: __AddIBanModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
    const [iBan, setIBan] = useState<string>(''); // State to hold the IBAN without "IR"
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    function submitHandler() {
        setLoading(true);
        const parsedIBan = iBan.slice(2);
        post(API.bankAccount.addIBanNumber, { iBan: parsedIBan }) // Add "IR" when submitting
            .then((_) => {
                props.onFinish();
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    }

    const handleIBanChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = faNumToEnNum(e.target.value);

        // Allow only numeric input
        const numericValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters

        // Allow only the input after "IR"
        if (numericValue.length === 0) {
            setIBan('');
        } else if (numericValue.length <= 24) {
            // Store only the part after "IR"
            setIBan(`IR${numericValue.length === 1 ? numericValue : numericValue}`);
        }
    };

    return (
        <SiPayModal maxWidth={400} isOpen={isOpen} onClose={props.onClose} title="افزودن شماره شبا">
            <h4 className="font-bold text-base text<-darkPurple-100 mb-2">شماره شبا:</h4>
            <div style={{ direction: 'ltr' }}>
                <Input
                    inputMode="numeric"
                    prefix={<BankIcon symbol={detectBankByIBan(`${iBan}`)} />}
                    type="text"
                    value={iBan} // Show "IR" when iBan has value, otherwise show empty
                    onChange={handleIBanChange} // Use the new change handler
                    placeholder={'IR۰۶۰۵۶۰۶۱۱۸۲۸۰۰۵۰۳۲۹۵۶۳۸۱ : مثال'} // Show placeholder when iBan is empty
                    onPressEnter={submitHandler}
                />
            </div>
            <div className="flex items-center gap-2 my-5">
                <BsFillInfoSquareFill className={'text-warning-light'} />
                <p className="font-medium text-sm text-darkPurple-100">شماره شبا باید به نام صاحب حساب کاربری باشد!</p>
            </div>
            <Button
                disabled={iBan.length < 26}
                loading={loading}
                onClick={submitHandler}
                className="mt-6 w-full"
                type="primary"
            >
                افزودن شماره شبا
            </Button>
        </SiPayModal>
    );
};
